import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './LanguageSwitch.less';

const LanguageSwitch = (props) => {
  const { i18n } = useTranslation();
  const [language, setLanguage] = useState(i18n.language);
  const [isOpen, setIsOpen] = useState(false); // Manage dropdown state

  useEffect(() => {
    const savedLanguage = sessionStorage.getItem('selectedLanguage');
    
    if (savedLanguage) {
      i18n.changeLanguage(savedLanguage).then(() => {
        setLanguage(savedLanguage);
      }).catch((error) => {
        console.error('Error changing language:', error);
      });
    } else {
      i18n.changeLanguage('es').then(() => {
        setLanguage('es');
      }).catch((error) => {
        console.error('Error changing language:', error);
      });
    }
  }, [i18n]);

  const changeLanguage = (lang) => {
    if (typeof window !== 'undefined') sessionStorage.setItem('selectedLanguage', lang);
    i18n.changeLanguage(lang).then(() => {
      setLanguage(lang);
      setIsOpen(false); // Close dropdown after selection
    }).catch((error) => {
      console.error('Error changing language:', error);
    });
  };

  const handleMouseEnter = () => {
    setIsOpen(true); // Open dropdown on hover
  };

  const handleMouseLeave = () => {
    setIsOpen(false); // Close dropdown when mouse leaves
  };

  const getFlagForLanguage = (lang) => {
    switch (lang) {
      case 'es':
        return "/assets/centropuerto/Flags/chile-flag.png";
      case 'en':
        return "/assets/centropuerto/Flags/usa-flag.png";
      case 'pt':
        return "/assets/centropuerto/Flags/brazil-flag.png";
      default:
        return "/assets/centropuerto/Flags/chile-flag.png";
    }
  };

  return (
    <div 
      className={`language_changer_dropdown ${isOpen ? 'open' : ''}`}
      onMouseEnter={handleMouseEnter} // Open on hover
      onMouseLeave={handleMouseLeave} // Close when mouse leaves
    >
      <div className="current-language">
        <img
          src={getFlagForLanguage(language)}
          alt={`${language} Flag`}
          style={{ width: 20, marginRight: 8 }} 
        />
        {language.toUpperCase()}
        <img
          src="/assets/ivergrama/Home/Down-arrow.svg"
          alt={'whiteDownArrow'}
          style={{ width: 17, marginLeft: 10 }}
        />
      </div>
      {isOpen && (
        <div className="dropdown-menu">
          <a className="dropdown-item" onClick={() => changeLanguage('es')}>
            <img src="/assets/centropuerto/Flags/chile-flag.png" alt="ES Flag" style={{ width: 20, marginRight: 8 }} />
            ES
          </a>
          <a className="dropdown-item" onClick={() => changeLanguage('en')}>
            <img src="/assets/centropuerto/Flags/usa-flag.png" alt="EN Flag" style={{ width: 20, marginRight: 8 }} />
            EN
          </a>
        </div>
      )}
    </div>
  );
};

export default LanguageSwitch;



// WEBPACK FOOTER //
// ./src/features/themes/ThemeEleven/components/LanguageSwitch.js